
import React from 'react';

export default class CommonActions {
    static renderWaitLoading = (skinName) =>{
        let styleSheet = {};
        styleSheet.height= window.innerHeight;
    return (<div id = {skinName + "_loading"} className = "first-loading" style = {styleSheet}>
                <div  className = "icondefault"></div><div  className = "icondefault"></div><div className = "icondefault"></div><div className = "logo"></div>
                <span className = "span-first-loading">Loading ...</span>
        </div>)
    }

    static renderComponentLoading = (skinName, clazzName) => {
        return (<div id={skinName + "_loading-component"} className={`loading-component ${clazzName || ''}`}>
            <div className={"iconcontent"}>
                <div className="icondefault"></div>
                <div className="icondefault"></div>
                <div className="icondefault"></div>
            </div>
        </div>)
    }

    static lazyWithPreload (factory) {
        const Component = React.lazy(factory);
        Component.preload = factory;
        return Component;
    }

    static getExternalCssLink (url) {
        let extLink = document.createElement("link");

        extLink.type = "text/css";
        extLink.rel = "preload stylesheet";
        extLink.as = "style";
        extLink.charset="UTF-8"
        extLink.onload = function() {
            extLink.rel = "stylesheet";
        }
        extLink.href = url;
        return extLink;
    }
}


// WEBPACK FOOTER //
// ./src/app/actions/CommonActions.js